// components/AvailabilitySlotList.jsx
import React from "react";
import { FaCaretLeft, FaCaretRight } from "react-icons/fa";
import { Buttton } from "..";

const AvailabilitySlotList = ({
    availableSlot = [],
    onPerClick,
    onTimeClick,
    onNextClick,
}) => {
    return (
        <div className="availability-slot-list">
            <div>
                <Buttton.Buttton
                    children={<FaCaretLeft />}
                    className="btn-solid-Aqua_Pale"
                    onClick={onPerClick}
                />
            </div>

            {availableSlot.map((slot, index) => {
                const date = new Date(slot.currentDate);
                const formattedDate = date
                    .toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                    })
                    .replace("/", " . ");
                const dayShort = date
                    .toLocaleDateString("en-US", { weekday: "short" })
                    .toUpperCase();
                const isToday =
                    date.toDateString() === new Date().toDateString()
                        ? "vaasd-active"
                        : "";

                return (
                    <div key={index} className="availability-slot">
                        <div className={`view-all-availability-slot-date ${isToday}`}>
                            <div className="exado_body_text_two">{formattedDate}</div>
                            <div className="exado-title-six">{dayShort}</div>
                        </div>
                        {slot?.availableTime?.length > 0 ? (
                            slot.availableTime
                                .filter(time => time !== "0001-01-01T00:00:00")
                                .map((time, i) => {
                                    const formattedTime = new Date(time).toLocaleTimeString("en-US", {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        hour12: true,
                                    });

                                    return (
                                        <div
                                            key={i}
                                            className="view-all-availability-slot-time exado_body_text_two"
                                            onClick={() => onTimeClick(time)}
                                        >
                                            {formattedTime}
                                        </div>
                                    );
                                })
                        ) : (
                            <div className="empty-blk"></div>
                        )}
                    </div>
                );
            })}

            <div>
                <Buttton.Buttton
                    children={<FaCaretRight />}
                    className="btn-solid-Aqua_Pale"
                    onClick={onNextClick}
                />
            </div>
        </div>
    );
};

export default AvailabilitySlotList;
